import type {Result, UseCase} from 'framework';
import type {WorkoutError} from '../../domain/errors';
import type {Workout} from '../../domain/workout';
import type {WorkoutId} from '../../domain/workout-id.value-object';
import type {WorkoutRepository} from '../ports/workout.repository';

export type DiscardWorkoutInput = {
  readonly workoutId: WorkoutId;
};

export class DiscardWorkout implements UseCase<[DiscardWorkoutInput], Workout> {
  constructor(private readonly repository: WorkoutRepository) {}

  execute(input: DiscardWorkoutInput): Promise<Result<Workout, WorkoutError>> {
    return this.repository.discardWorkout(input.workoutId);
  }
}
